import dashaPic from "@/public/images/artists/dasha.jpg";
import { Artist } from "@/types/types";

export const dasha = {
  id: "275",
  name: "Dasha",
  image: dashaPic,
  description: `Dasha's voice is sharp and commanding, with a tight rock tone and a clean, controlled punch.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdasha-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Rock", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 57,
        high: 66,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
